import ResourceLoaderProto from 'src/core/core3-depricated/app/resource-loader-proto';

const appLoaderFunction = () => import(/* webpackChunkName: "doc" */ './app.js');

module.exports = class SharedViewDocViewAppLoader extends ResourceLoaderProto {

    constructor(appParams) {
        super(appParams);

        this.domElementId = appParams.containerId;
    }

    resources() {
        return [
            this._loadCSS('doc'),
            this._loadAPP(appLoaderFunction)
        ];
    }
};
